/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OrganisationIdIndexRouteImport } from './routes/$organisationId.index'
import { Route as OrganisationsIndexRouteImport } from './routes/organisations.index'
import { Route as RemovalRequestsTokenRouteImport } from './routes/removal-requests.$token'
import { Route as OrganisationsOrganisationIdIndexRouteImport } from './routes/organisations.$organisationId.index'
import { Route as OrganisationsOrganisationIdCandidacyIdIndexRouteImport } from './routes/organisations.$organisationId.$candidacyId.index'
import { Route as OrganisationsOrganisationIdCandidacyIdProfileRouteImport } from './routes/organisations.$organisationId.$candidacyId.profile'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisationIdIndexRoute = OrganisationIdIndexRouteImport.update({
  id: '/$organisationId/',
  path: '/$organisationId/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisationsIndexRoute = OrganisationsIndexRouteImport.update({
  id: '/organisations/',
  path: '/organisations/',
  getParentRoute: () => rootRouteImport,
} as any)
const RemovalRequestsTokenRoute = RemovalRequestsTokenRouteImport.update({
  id: '/removal-requests/$token',
  path: '/removal-requests/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisationsOrganisationIdIndexRoute =
  OrganisationsOrganisationIdIndexRouteImport.update({
    id: '/organisations/$organisationId/',
    path: '/organisations/$organisationId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganisationsOrganisationIdCandidacyIdIndexRoute =
  OrganisationsOrganisationIdCandidacyIdIndexRouteImport.update({
    id: '/organisations/$organisationId/$candidacyId/',
    path: '/organisations/$organisationId/$candidacyId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganisationsOrganisationIdCandidacyIdProfileRoute =
  OrganisationsOrganisationIdCandidacyIdProfileRouteImport.update({
    id: '/organisations/$organisationId/$candidacyId/profile',
    path: '/organisations/$organisationId/$candidacyId/profile',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/removal-requests/$token': typeof RemovalRequestsTokenRoute
  '/$organisationId/': typeof OrganisationIdIndexRoute
  '/organisations/': typeof OrganisationsIndexRoute
  '/organisations/$organisationId/': typeof OrganisationsOrganisationIdIndexRoute
  '/organisations/$organisationId/$candidacyId/profile': typeof OrganisationsOrganisationIdCandidacyIdProfileRoute
  '/organisations/$organisationId/$candidacyId/': typeof OrganisationsOrganisationIdCandidacyIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/removal-requests/$token': typeof RemovalRequestsTokenRoute
  '/$organisationId': typeof OrganisationIdIndexRoute
  '/organisations': typeof OrganisationsIndexRoute
  '/organisations/$organisationId': typeof OrganisationsOrganisationIdIndexRoute
  '/organisations/$organisationId/$candidacyId/profile': typeof OrganisationsOrganisationIdCandidacyIdProfileRoute
  '/organisations/$organisationId/$candidacyId': typeof OrganisationsOrganisationIdCandidacyIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/removal-requests/$token': typeof RemovalRequestsTokenRoute
  '/$organisationId/': typeof OrganisationIdIndexRoute
  '/organisations/': typeof OrganisationsIndexRoute
  '/organisations/$organisationId/': typeof OrganisationsOrganisationIdIndexRoute
  '/organisations/$organisationId/$candidacyId/profile': typeof OrganisationsOrganisationIdCandidacyIdProfileRoute
  '/organisations/$organisationId/$candidacyId/': typeof OrganisationsOrganisationIdCandidacyIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/removal-requests/$token'
    | '/$organisationId/'
    | '/organisations/'
    | '/organisations/$organisationId/'
    | '/organisations/$organisationId/$candidacyId/profile'
    | '/organisations/$organisationId/$candidacyId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/removal-requests/$token'
    | '/$organisationId'
    | '/organisations'
    | '/organisations/$organisationId'
    | '/organisations/$organisationId/$candidacyId/profile'
    | '/organisations/$organisationId/$candidacyId'
  id:
    | '__root__'
    | '/'
    | '/removal-requests/$token'
    | '/$organisationId/'
    | '/organisations/'
    | '/organisations/$organisationId/'
    | '/organisations/$organisationId/$candidacyId/profile'
    | '/organisations/$organisationId/$candidacyId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  RemovalRequestsTokenRoute: typeof RemovalRequestsTokenRoute
  OrganisationIdIndexRoute: typeof OrganisationIdIndexRoute
  OrganisationsIndexRoute: typeof OrganisationsIndexRoute
  OrganisationsOrganisationIdIndexRoute: typeof OrganisationsOrganisationIdIndexRoute
  OrganisationsOrganisationIdCandidacyIdProfileRoute: typeof OrganisationsOrganisationIdCandidacyIdProfileRoute
  OrganisationsOrganisationIdCandidacyIdIndexRoute: typeof OrganisationsOrganisationIdCandidacyIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organisationId/': {
      id: '/$organisationId/'
      path: '/$organisationId'
      fullPath: '/$organisationId/'
      preLoaderRoute: typeof OrganisationIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organisations/': {
      id: '/organisations/'
      path: '/organisations'
      fullPath: '/organisations/'
      preLoaderRoute: typeof OrganisationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/removal-requests/$token': {
      id: '/removal-requests/$token'
      path: '/removal-requests/$token'
      fullPath: '/removal-requests/$token'
      preLoaderRoute: typeof RemovalRequestsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organisations/$organisationId/': {
      id: '/organisations/$organisationId/'
      path: '/organisations/$organisationId'
      fullPath: '/organisations/$organisationId/'
      preLoaderRoute: typeof OrganisationsOrganisationIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organisations/$organisationId/$candidacyId/': {
      id: '/organisations/$organisationId/$candidacyId/'
      path: '/organisations/$organisationId/$candidacyId'
      fullPath: '/organisations/$organisationId/$candidacyId/'
      preLoaderRoute: typeof OrganisationsOrganisationIdCandidacyIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organisations/$organisationId/$candidacyId/profile': {
      id: '/organisations/$organisationId/$candidacyId/profile'
      path: '/organisations/$organisationId/$candidacyId/profile'
      fullPath: '/organisations/$organisationId/$candidacyId/profile'
      preLoaderRoute: typeof OrganisationsOrganisationIdCandidacyIdProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  RemovalRequestsTokenRoute: RemovalRequestsTokenRoute,
  OrganisationIdIndexRoute: OrganisationIdIndexRoute,
  OrganisationsIndexRoute: OrganisationsIndexRoute,
  OrganisationsOrganisationIdIndexRoute: OrganisationsOrganisationIdIndexRoute,
  OrganisationsOrganisationIdCandidacyIdProfileRoute:
    OrganisationsOrganisationIdCandidacyIdProfileRoute,
  OrganisationsOrganisationIdCandidacyIdIndexRoute:
    OrganisationsOrganisationIdCandidacyIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
